"use strict";

var _classCallCheck = require("/tmp/travis-listener/essote-henkilotietolomake/master/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/travis-listener/essote-henkilotietolomake/master/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/tmp/travis-listener/essote-henkilotietolomake/master/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/tmp/travis-listener/essote-henkilotietolomake/master/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/tmp/travis-listener/essote-henkilotietolomake/master/node_modules/@babel/runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var api_1 = require("./models/api");

var MetaformTextFieldComponent_1 = require("./MetaformTextFieldComponent");

var VisibleIfEvaluator_1 = __importDefault(require("./VisibleIfEvaluator"));

var MetaformRadioFieldComponent_1 = require("./MetaformRadioFieldComponent");

var MetaformSubmitFieldComponent_1 = require("./MetaformSubmitFieldComponent");
/**
 * Component for metaform field
 */


var MetaformFieldComponent =
/*#__PURE__*/
function (_react_1$default$Comp) {
  _inherits(MetaformFieldComponent, _react_1$default$Comp);

  /**
   * Constructor
   *
   * @param props component props
   */
  function MetaformFieldComponent(props) {
    var _this;

    _classCallCheck(this, MetaformFieldComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MetaformFieldComponent).call(this, props));
    /**
     * Renders field title
     */

    _this.renderTitle = function () {
      if (!_this.props.field.title) {
        return null;
      }

      var title = "".concat(_this.props.field.title) + (_this.props.field.required ? " *" : "");
      return react_1.default.createElement("div", {
        className: "metaform-field-label-container"
      }, react_1.default.createElement("label", {
        className: "metaform-field-label"
      }, " ", title, "\xA0"));
    };
    /**
     * Renders field's input
     */


    _this.renderInput = function () {
      switch (_this.props.field.type) {
        case api_1.MetaformFieldType.Text:
          return react_1.default.createElement(MetaformTextFieldComponent_1.MetaformTextFieldComponent, {
            formReadOnly: _this.props.formReadOnly,
            fieldLabelId: _this.getFieldLabelId(),
            fieldId: _this.getFieldId(),
            field: _this.props.field,
            onValueChange: _this.onValueChange,
            value: _this.getFieldValue(),
            onFocus: _this.onFocus
          });

        case api_1.MetaformFieldType.Radio:
          return react_1.default.createElement(MetaformRadioFieldComponent_1.MetaformRadioFieldComponent, {
            renderIcon: _this.props.renderIcon,
            formReadOnly: _this.props.formReadOnly,
            fieldLabelId: _this.getFieldLabelId(),
            fieldId: _this.getFieldId(),
            field: _this.props.field,
            onValueChange: _this.onValueChange,
            value: _this.getFieldValue(),
            onFocus: _this.onFocus
          });

        case api_1.MetaformFieldType.Submit:
          return react_1.default.createElement(MetaformSubmitFieldComponent_1.MetaformSubmitFieldComponent, {
            formReadOnly: _this.props.formReadOnly,
            fieldLabelId: _this.getFieldLabelId(),
            fieldId: _this.getFieldId(),
            field: _this.props.field,
            onClick: _this.props.onSubmit,
            value: _this.getFieldValue()
          });

        default:
          return react_1.default.createElement("div", {
            style: {
              color: "red"
            }
          }, " Unknown field type ", _this.props.field.type, "\xA0");
      }
    };
    /**
     * Renders field help
     */


    _this.renderHelp = function () {
      if (!_this.props.field.help) {
        return null;
      }

      return react_1.default.createElement("div", {
        className: "metaform-field-help-container"
      }, react_1.default.createElement("small", {
        className: "metaform-field-help"
      }, " ", _this.props.field.help, "\xA0"));
    };
    /**
     * Returns field's id
     */


    _this.getFieldId = function () {
      return "".concat(_this.props.metaformId, "-field-").concat(_this.props.field.name);
    };
    /**
     * Returns field label's id
     */


    _this.getFieldLabelId = function () {
      return "".concat(_this.getFieldId(), "-label");
    };
    /**
     * Returns field's value
     *
     * @returns field's value
     */


    _this.getFieldValue = function () {
      if (!_this.props.field.name) {
        return null;
      }

      return _this.props.getFieldValue(_this.props.field.name);
    };
    /**
     * Event handler for field value change
     */


    _this.onValueChange = function (value) {
      if (!_this.props.field.name) {
        return null;
      }

      _this.props.setFieldValue(_this.props.field.name, value);
    };
    /**
     * Event handler for field value change
     */


    _this.onFocus = function () {
      _this.setState({
        pristine: false
      });
    };

    _this.state = {
      pristine: true
    };
    return _this;
  }
  /**
   * Component render method
   */


  _createClass(MetaformFieldComponent, [{
    key: "render",
    value: function render() {
      if (!VisibleIfEvaluator_1.default.isVisible(this.props.field["visible-if"], this.props.getFieldValue)) {
        return null;
      }

      var classNames = ["metaform-field"];

      if (this.state.pristine) {
        classNames.push("pristine");
      }

      return react_1.default.createElement("div", {
        className: classNames.join(" "),
        key: this.getFieldId()
      }, this.renderTitle(), this.renderInput(), this.renderHelp());
    }
  }]);

  return MetaformFieldComponent;
}(react_1.default.Component);

exports.MetaformFieldComponent = MetaformFieldComponent;